import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { superUserRoleList } from "../../../redux/actions/superUserAction";
import "../../products/productDetail.css";
import SuperUserRoleTableData from "../../superUsers/superUserRole/superUserRoleTableData";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import NumberPagination from "../../../components/Pagination/number-pagination";

const SuperUserRoleTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [superUserRoleListData, setSuperUserRoleListData] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    fetchSuperList();
  }, [page, search]);

  const fetchSuperList = () => {
    dispatch(superUserRoleList({ search, page }, onSuccess, onError));
  };
  const onSuccess = (data) => {
    setLoading(false);
    setSuperUserRoleListData(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads " width={"10%"}>
                  Role ID
                </th>
                <th className="table-heads " width={"10%"}>
                  Role Name
                </th>
                <th className="table-heads " width={"10%"}>
                  Role Level
                </th>
                <th className="table-heads " width={"22%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : superUserRoleListData?.roles?.length > 0 ? (
                <>
                  {superUserRoleListData?.roles?.map((eachRow, index) => (
                    <SuperUserRoleTableData
                      key={eachRow.id}
                      data={eachRow}
                      index={index}
                      fetchSuperList={fetchSuperList}
                      currentPage={
                        superUserRoleListData?.pagination?.currentPage
                      }
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading == true ? `loading-event` : ""}>
          {superUserRoleListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={superUserRoleListData?.pagination?.currentPage}
              totalPages={superUserRoleListData?.pagination?.totalPages}
              path={"/super-user/role"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default SuperUserRoleTable;
